module.exports = __webpack_public_path__ + "img/uk_success_6.5c2d146e.png";